<button #toggleButton
        class="btn btn-primary mx-2 px-3 py-2"
        (click)="this.toggleSidebar()">
  <div #wrapper>
    <ng-content #content></ng-content>
  </div>
  @if (wrapper.children.length === 0) {
  <div>Toggle</div>
  }
</button>